import { PlannerGlobals } from 'src/components/Planner/planner/planner-globals';
import { refreshFloorView } from 'src/components/Planner/planner/plannerCacheInvalidation';
import { SetDeviceDesignResponse } from 'src/api/v1/design-ApiSlice';

export interface Design {
    id: number;
    image: string;
    manufacturer: string;
    color: string;
}

export function parseDesigns(html: string): Design[] {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.from(doc.querySelectorAll('.device_design')).flatMap((el) => {
        const id = Number(el.getAttribute('data-id'));
        if (!id) return [];
        return [{
            id,
            image: el.querySelector('img')?.getAttribute('src') ?? '',
            manufacturer: el.querySelector('.manu')?.textContent?.trim() ?? '',
            color: el.querySelector('.name')?.textContent?.trim() ?? '',
        }];
    });
}

export function applyDesignChange(response: SetDeviceDesignResponse, selectedDesignId: number): void {
    response.changedProductsIdsWithImages.forEach(({ planObjectId, image }) => {
        PlannerGlobals.devices.forEach((dev: any) => {
            if (dev.deviceId === planObjectId) {
                dev.image_url = image;
                dev.device_manufacturer = response.manufacturer;
                dev.device_color = response.color;
                dev.product_id = selectedDesignId;
            }
        });
    });
    refreshFloorView();
}
